import React from "react";
import { GENDER_FEATURE } from "../Constant";
import {
  Checkbox,
  Input,
  FormElement,
  Form,
  FormSection
} from "../../../../Common/UI/Index";
import { InputType } from "../../../../Common/UI/Types";
import { DatasourceDetails } from "./Helper";
interface BandingFormProps {
  /**
   * Type of Band
   */
  type: string;
  /**
   * Method for onChanging
   */
  // OnChange: (val: string) => ((e: React.SyntheticEvent<any, Event>) => void);
  onChange: (val: string) => ((isChecked: boolean) => void);
  /**
   * Redux state values
   */
  currentValues: string[];
  /**
   * Contains item source
   */
  dataSource: DatasourceDetails[];
  /**
   * Gender band name
   */
  genderBandName: string;
  /**
   * Handler for name change
   */
  onNameChange: (e: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

/**
 * Responsible for rendering gender banding popup
 * @returns Gender banding popup view
 */
export const BandingGenderFormView: React.FC<BandingFormProps> = (props: BandingFormProps) => {
  const {
    type,
    onChange,
    currentValues,
    dataSource,
    genderBandName,
    onNameChange
  } = props;
  const labelText = type === GENDER_FEATURE ? "Gender" : "Ethnicity Code List";

  /**
   * Method for making the gender fields checked
   * @param val Logical value
   * @returns boolean value
   */
  const checkedGenderBands = (val: string): boolean => {
    return currentValues?.some((item: string) => item === val);
  };

  return (
    <Form>
      <FormSection>
        <FormElement
          fieldId="band-name"
          labelText="Name"
          mandatory={true}
          id="ebt-outputConfig-banding-genderForm"
        >
          <Input
            type={InputType.Text}
            name="band-name"
            value={genderBandName}
            onChange={onNameChange}
            id="ebt-outputConfig-banding-genderBand"
          />
        </FormElement>
        <FormElement
          labelText={labelText}
          mandatory={true}
        >
          <div className="ebt-output-bandform__gender">
            <FormElement
              labelText="Where Gender is"
              mandatory={true}
            />
            {dataSource?.map((item: DatasourceDetails, idx: number) => {
              return (
                <Checkbox
                  labelText={item.displayName}
                  key={idx}
                  onChange={onChange(item.logicalValue)}
                  checked={checkedGenderBands(item.logicalValue)}
                  id={`ebt-outputConfig-banding-gender-${idx + 1}`}
                />
              );
            })
            }
          </div>
        </FormElement>
      </FormSection>
    </Form>
  );
};
